import { 
  CurrencyCircleDollar, 
  House,
  Lightning,
  Drop,
  Flame,
  Recycle,
  Buildings
} from '@phosphor-icons/react';
import { Icon } from '@phosphor-icons/react';

export interface FinanceEntry {
  id: string;
  type: 'income' | 'expense';
  amount: number;
  description: string;
  category: string;
  date: string;
  property_id?: string;
  apartment_id?: string;
  recurring?: boolean;
  recurrence_interval?: 'monthly' | 'quarterly' | 'yearly';
  organization_id?: string;
  created_at?: string;
}

export interface Property {
  id: string;
  name?: string;
}

export interface Apartment {
  id: string;
  apartment_number?: string;
  property_id?: string;
}

export interface IncomeFormData {
  amount: string;
  description: string;
  category: string;
  date: string;
  property_id: string;
  apartment_id: string;
  recurring: boolean;
  recurrence_interval: 'monthly' | 'quarterly' | 'yearly';
}

export interface ExpenseFormData {
  amount: string;
  description: string;
  category: string;
  date: string;
  property_id: string;
  recurring: boolean;
  recurrence_interval: 'monthly' | 'quarterly' | 'yearly';
}

export interface ExpenseCategory {
  id: string;
  label: string;
  icon: Icon;
  color: string;
}

export interface IncomeType {
  id: string;
  label: string;
}

// Expense categories with icons
export const EXPENSE_CATEGORIES: ExpenseCategory[] = [
  { id: 'heating', label: 'Värme', icon: Flame, color: 'text-orange-600 bg-orange-100' },
  { id: 'water', label: 'Vatten', icon: Drop, color: 'text-blue-600 bg-blue-100' },
  { id: 'electricity', label: 'El', icon: Lightning, color: 'text-yellow-600 bg-yellow-100' },
  { id: 'garbage', label: 'Sopor', icon: Recycle, color: 'text-green-600 bg-green-100' },
  { id: 'insurance', label: 'Försäkring', icon: Buildings, color: 'text-purple-600 bg-purple-100' },
  { id: 'maintenance', label: 'Underhåll', icon: House, color: 'text-slate-600 bg-slate-100' },
  { id: 'other', label: 'Övrigt', icon: CurrencyCircleDollar, color: 'text-slate-600 bg-slate-100' }
];

// Income types
export const INCOME_TYPES: IncomeType[] = [
  { id: 'rent', label: 'Hyra/Avgift' },
  { id: 'parking', label: 'Parkering' },
  { id: 'storage', label: 'Förråd' },
  { id: 'laundry', label: 'Tvättstuga' },
  { id: 'other', label: 'Övrigt' }
];
